import Auth from '../auth/Auth';
import BidPlan from '../models/BidPlan';
import BidPlanResult from "../models/BidPlanResult";
import { WebClient } from './WebClient'

class ApiBidding extends WebClient {
    async getBidPlans(customerId: number): Promise<BidPlan[]> {
        const url = `/bidding/${customerId}`;

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || [];
            }
            return [];
        }).catch(() => { return []; });
    }

    async getBidPlan(customerId: number, planId: number): Promise<BidPlanResult | null> {
        const url = `/bidding/plan/${customerId}/${planId}`;

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
            return null;
        }).catch(() => { return null; });
    }

    async getBidPlanInfo(customerId: number, planId: number): Promise<BidPlanResult | null> {
        const url = `/bidding/plan/info/${customerId}/${planId}`;

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
            return null;
        }).catch(() => { return null; });
    }

    async createBidPlan(planId: number): Promise<boolean> {
        const url = `/bidding/createplan/${planId}`;

        return this.get(url, Auth.getAuthToken()).then(res => {
            return res.status === 200;
        }).catch(() => { return false; });
    }
}

export default new ApiBidding();
